// src/services/lpo.js
const API_BASE = 'https://new.sbdemolition.online/api/lpo';

async function apiRequest(endpoint, options = {}) {
  const authToken = localStorage.getItem('authToken');
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null;
  const userToken = user ? user.token : null;

  const headers = {
    'Content-Type': 'application/json',
    ...(authToken && { 'Authorization': `Bearer ${authToken}` }),
    ...(token && { 'Authorization': `Bearer ${token}` }),
    ...(userToken && { 'Authorization': `Bearer ${userToken}` }),
    ...options.headers
  };

  console.log('🌐 LPO Request:', `${API_BASE}${endpoint}`);
  console.log('📤 Request Data:', options.body);

  const response = await fetch(`${API_BASE}${endpoint}`, {
    ...options,
    credentials: 'include',
    headers
  });

  console.log('📊 LPO Response:', response.status, response.url);

  if (response.status === 401) {
    localStorage.clear();
    window.location.href = '/login';
    throw new Error('Unauthorized - redirecting to login');
  }

  const text = await response.text();
  
  // لو HTML، نرجع fallback
  if (text.trim().startsWith('<!DOCTYPE') || text.trim().startsWith('<html')) {
    console.warn('⚠️ Got HTML instead of JSON. Server might be down.');
    return {
      success: false,
      error: 'Server returned HTML instead of JSON. Check API endpoint.',
      data: []
    };
  }

  try {
    return JSON.parse(text);
  } catch (e) {
    console.error('JSON Parse Error:', e, 'Raw text:', text);
    throw new Error('Invalid JSON response from server');
  }
}

export const lpoAPI = {
  list: (projectId) => apiRequest(`/list.php?projectId=${projectId}`),
  
  create: (data) => {
    console.log('📤 Creating LPO with data:', data);
    return apiRequest('/create.php', {
      method: 'POST',
      body: JSON.stringify(data)
    });
  },
  
  delete: (id) => apiRequest(`/delete.php?id=${id}`, { method: 'DELETE' })
};
